import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import { AppData } from '../../constants/app-data';
import { DataService } from '../../data.service';
import { UrlConstant } from '../../constants/url-constant';
import { GlobalConstant } from '../../constants/global-constant';
import { NotificationService } from "../../services/notification.service";

@Component({
  selector: 'app-change-pass',
  templateUrl: './change-pass.component.html',
  styleUrls: ['./change-pass.component.css']
})
export class ChangePassComponent implements OnInit {
  form = new FormGroup({
  	token: new FormControl(''),
  	loginUserStatus: new FormControl(''),
    userId: new FormControl(''),
    password: new FormControl(''),
    newPassword: new FormControl('', [ Validators.minLength(8), Validators.maxLength(50) ]),
    confirmNewPassword: new FormControl('', [ Validators.minLength(8), Validators.maxLength(50) ])
  });
  message = '';
  
  constructor(private routeParams: ActivatedRoute, private router: Router,
  	private dataService: DataService, public appData: AppData,
  	public notificationService: NotificationService) { }

  ngOnInit(): void {
	// { 'userId': username, 'token': data.token, 'loginUserStatus': 'FORCE-PASSWORD-CHANGE' }
	let loginTempData =  this.dataService.getFromLocalStorage(GlobalConstant.KEY_LOCAL_STORAGE_LOGIN_TEMP_DATA);
	
  	let userId = this.routeParams.snapshot.params['userId'];
  	let token = this.routeParams.snapshot.params['token'];
  	let loginUserStatus = this.routeParams.snapshot.params['loginUserStatus'];
  	
  	if(loginTempData != "") {
  	// if(loginTempData != undefined && loginTempData!=null) {
		userId = loginTempData['userId'];
		token = loginTempData['token'];
		loginUserStatus = loginTempData['loginUserStatus'];
	} else {
		userId = this.appData.userId;
		token = this.appData.loginSuccessToken;
		if(token == null || token == undefined || token == ''){
			token = this.dataService.getApiKeyHeaderFromLocalStorage();
		}
	}
	
  	this.form.patchValue({'userId' : userId, 'token' : token});
  	if(loginUserStatus !== undefined)
  	    this.form.patchValue({'loginUserStatus' : loginUserStatus});
  	//this.routeParams.snapshot.data['type'];
  	
  }

  async onSubmit() {
   	var reqBody = this.form.value;
   	 if(reqBody.newPassword !== reqBody.confirmNewPassword){
   	 	this.notificationService.error("New Password is not matching with Confirm Password");
   	 	return;
   	 }
   	 reqBody.token =  this.dataService.getApiKeyHeaderFromLocalStorage();
   	 this.dataService.sendPostRequestWithBody(UrlConstant.apiChangePassword, reqBody).subscribe((data: any)=>{
 		console.log(data);
	      if("SUCCESS" === data.status){
	      	console.log("success code");
	      	this.message = "Password updated Successfully.";
      		//this.router.navigate(['/dashboard', { 'userId': '' }]);
      		
      		this.appData.loginInvalid.next(false);
      		this.appData.isAuthenticated.next(true);
      		this.appData.userId = reqBody.userId;
      		this.appData.loginSuccessToken = reqBody.token;
      		
      		if (window.localStorage) {
			  console.log('localStorage supported');
			  this.dataService.setApiKeyHeaderToLocalStorage(reqBody.token);
			}
			this.notificationService.success(this.message);
			this.dataService.getLoggedInUserDataWithAllPrivileges({"userId": reqBody.userId });
      		this.router.navigate(['/dashboard', { 'userId': reqBody.userId }]);
      		
	      } else {
	        console.log("fail code");
	        this.message = "Unable to update Password. Please retry.";
	        this.notificationService.error(this.message);
      		//this.router.navigate(['/dashboard', { 'userId': username }]);
	      }
	  });
  }
  
}
